import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';
import { Link } from 'react-router-dom';

export default function About() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h1 className="text-5xl font-bold text-gray-900 mb-6">About Stratis Advisory</h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Strategic consulting expertise focused on financial services transformation and regulatory compliance
            </p>
          </div>
        </div>
      </section>

      {/* Company Story */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">Our Story</h2>
              <p className="text-lg text-gray-600 mb-6">
                Stratis Advisory was founded with a clear mission: to help financial services organizations navigate the increasingly complex regulatory landscape while executing strategic transformations that drive growth and innovation.
              </p>
              <p className="text-lg text-gray-600 mb-6">
                Based in Bratislava, we serve banks, insurers, and fintechs across Europe and beyond, providing specialized expertise in regulatory compliance, project management, and user experience design.
              </p>
              <p className="text-lg text-gray-600 mb-8">
                Our IGNITE methodology combines deep industry knowledge with proven implementation frameworks to deliver results that matter.
              </p>
              <Link to="/contact">
                <Button>Get in Touch</Button>
              </Link>
            </div>
            
            <div className="relative">
              <img 
                src="https://public.readdy.ai/ai/img_res/bf92fe1c60f4e53b916c026394fb521e.jpg"
                alt="Bratislava business district"
                className="rounded-xl shadow-lg object-cover w-full h-96"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Founder Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">Meet the Founder</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Leading Stratis Advisory with expertise in financial services strategy and regulatory compliance
            </p>
          </div>
          
          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-xl shadow-lg p-8 md:p-12">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center">
                <div className="md:col-span-1">
                  <img 
                    src="https://static.readdy.ai/image/036fbfb6a6a84f25228dac0e3f2f7322/380b29ae374c63dd714d2a9e396b6ac7.png"
                    alt="Stratis Advisory Founder"
                    className="rounded-xl object-cover w-full h-80 md:h-64"
                  />
                </div>
                
                <div className="md:col-span-2">
                  <h3 className="text-3xl font-bold text-gray-900 mb-4">Strategic Vision & Expertise</h3>
                  <p className="text-lg text-gray-600 mb-6">
                    I founded Stratis Advisory to bridge the gap between fintechs and traditional players to build growth together.
                  </p>
                  <p className="text-lg text-gray-600 mb-6">
                    With deep expertise in regulatory frameworks including DORA, MICA, FIDA, PSR, and IPR, I help both innovative fintechs and established financial institutions navigate complex compliance requirements while driving strategic transformation. My hands-on experience in project management and UX design enables me to deliver practical solutions that connect regulatory excellence with business growth.
                  </p>
                  
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
                    <div className="flex items-center">
                      <i className="ri-check-line text-green-500 mr-2"></i>
                      <span className="text-gray-700">10+ Years Experience</span>
                    </div>
                    <div className="flex items-center">
                      <i className="ri-check-line text-green-500 mr-2"></i>
                      <span className="text-gray-700">Regulatory Expert</span>
                    </div>
                    <div className="flex items-center">
                      <i className="ri-check-line text-green-500 mr-2"></i>
                      <span className="text-gray-700">PMO Specialist</span>
                    </div>
                    <div className="flex items-center">
                      <i className="ri-check-line text-green-500 mr-2"></i>
                      <span className="text-gray-700">UX Design Focus</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Approach */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">Our Approach</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              The IGNITE methodology combines strategic thinking with practical implementation
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-lightbulb-fill text-4xl text-purple-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Strategic Analysis</h3>
              <p className="text-gray-600">
                Deep dive into your current state, regulatory requirements, and strategic objectives to identify opportunities and challenges.
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-20 h-20 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-settings-fill text-4xl text-purple-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Tailored Solutions</h3>
              <p className="text-gray-600">
                Develop customized strategies and implementation plans that align with your specific business needs and regulatory environment.
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-20 h-20 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-rocket-fill text-4xl text-purple-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Rapid Execution</h3>
              <p className="text-gray-600">
                Implement solutions with structured project management and continuous monitoring to ensure successful outcomes.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">Our Values</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              The principles that guide our work and relationships with clients
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-white rounded-xl p-6 text-center shadow-lg">
              <div className="w-16 h-16 bg-purple-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-fill text-3xl text-purple-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Integrity</h3>
              <p className="text-gray-600">Honest, transparent communication and ethical business practices in all our engagements.</p>
            </div>
            
            <div className="bg-white rounded-xl p-6 text-center shadow-lg">
              <div className="w-16 h-16 bg-purple-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className="ri-star-fill text-3xl text-purple-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Excellence</h3>
              <p className="text-gray-600">Delivering high-quality solutions that exceed expectations and drive measurable results.</p>
            </div>
            
            <div className="bg-white rounded-xl p-6 text-center shadow-lg">
              <div className="w-16 h-16 bg-purple-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className="ri-team-fill text-3xl text-purple-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Partnership</h3>
              <p className="text-gray-600">Building long-term relationships based on trust, collaboration, and mutual success.</p>
            </div>
            
            <div className="bg-white rounded-xl p-6 text-center shadow-lg">
              <div className="w-16 h-16 bg-purple-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className="ri-flashlight-fill text-3xl text-purple-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Innovation</h3>
              <p className="text-gray-600">Embracing new technologies and methodologies to solve complex business challenges.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-purple-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">Ready to Work Together?</h2>
          <p className="text-xl text-purple-100 mb-8 max-w-3xl mx-auto">
            Let's discuss how Stratis Advisory can help your organization achieve its strategic objectives.
          </p>
          <Link to="/contact">
            <Button size="lg" className="bg-purple-900 text-white hover:bg-purple-800 whitespace-nowrap">
              Start a Conversation
            </Button>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
